import { inject, Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Action, State, StateContext } from '@ngxs/store';
import { WINDOW } from '@kaseya-utils';
import { LogInWithThirdPartySso } from '@pages/login/store/actions/log-in-with-third-party-sso.actions';

@State<void>({
  name: 'logInWithThirdPartySso',
})
@Injectable()
export class LogInWithThirdPartySsoState {
  private readonly domSanitizer = inject(DomSanitizer);
  private readonly window = inject(WINDOW);

  @Action(LogInWithThirdPartySso)
  logInWithThirdPartySso(_context: StateContext<void>, { samlLoginUrl }: LogInWithThirdPartySso): void {
    const sanitizedUrl = this.domSanitizer.sanitize(SecurityContext.URL, this.domSanitizer.bypassSecurityTrustUrl(samlLoginUrl));

    if (!sanitizedUrl) {
      return;
    }

    this.window.location.href = sanitizedUrl;
  }
}
